import * as _ from "lodash"
import { replaceDataArrays } from "../dynamicPricing/dynamicPricing.service"

export const GetSpeedTierIndex = (currentSpeed, plansData) => {
  if (!Array.isArray(plansData.speedTiers)) {
    throw new Error("No Speed Tiers found")
  }

  const foundSpeedTierIndex = plansData.speedTiers.findIndex(speedTier => {
    if (speedTier.min <= currentSpeed && speedTier.max >= currentSpeed) {
      return true
    }

    if (speedTier.min <= currentSpeed && !("max" in speedTier)) {
      return true
    }

    return false
  })

  if (foundSpeedTierIndex === -1) {
    throw new Error("No Relevant Speed Tier Found")
  }

  return foundSpeedTierIndex
}

export const GetSpeedTierObjectsFromPlans = (currentSpeed, data) => {
  if (!Array.isArray(data.speedTiers)) {
    throw new Error("No Speed Tiers found")
  }

  const mutableData = _.cloneDeep(data) // SLOOOOOOW!

  // Replace the data arrays for the speedTier plans
  mutableData.speedTiers = replaceDataArrays(mutableData.speedTiers)
  // Strip out ids from speedTiers
  mutableData.speedTiers = mutableData.speedTiers.map(speedTier => {
    delete speedTier.id
    return speedTier
  })

  const pickedSpeedTiers = mutableData.plans.map(plan => {
    if (!("relativeSpeedTierOffset" in plan.data)) {
      return null
    }

    const speedTierIndex =
      GetSpeedTierIndex(currentSpeed, data) + plan.data.relativeSpeedTierOffset

    if (speedTierIndex >= 0 && speedTierIndex < mutableData.speedTiers.length) {
      return mutableData.speedTiers[speedTierIndex]
    } else {
      return null // making null so we can then drop the relevant plan out
      // throw new Error("Out of bounds")
    }
  })

  return pickedSpeedTiers
}

export const replacePlansWithSpeedTiers = (currentSpeed, data) => {
  // just return data if we don't have speedTiers info
  if (!("speedTiers" in data)) {
    return data
  }

  const speedTiers = GetSpeedTierObjectsFromPlans(currentSpeed, data)

  let updatedData = _.cloneDeep(data)
  // remove speedTiers from the returned object
  delete updatedData.speedTiers

  // Replace the plans as needed
  updatedData.plans = speedTiers.map((speedTier, i) => {
    // return an unaltered plan if there's no speed tier to use
    if (speedTier === null) {
      if (!("relativeSpeedTierOffset" in data.plans[i].data)) {
        return data.plans[i]
      }
      return null // data.plans[i]
    }

    // strip out the min, max keys from speedTier
    const strippedSpeedTier = _.cloneDeep(speedTier)
    delete strippedSpeedTier.min
    delete strippedSpeedTier.max

    // we now need to merge the part of the speed tier with the plan
    // A customizer which uses arrays from strippedSpeedTier instead of doing
    // the weird merge with them
    const customizer = (a, b) => {
      if (Array.isArray(a)) {
        return b
      }

      return undefined
    }

    return _.mergeWith(data.plans[i], strippedSpeedTier, customizer)
  })

  updatedData.plans = updatedData.plans.filter(plan => plan !== null)

  return updatedData
}
